<div class="sheet">
  <div class="line">
    <h4 class="upper">{{ 'SETTINGS.TITLE' | translate }}</h4>
    <img class="icon-xl" (click)="close()" [src]="'close.svg' | themeSource" alt="close" />
  </div>

  @if (hasMultiLanguage()) {
    <div>
      <h6>{{ 'SETTINGS.LANGUAGE' | translate }}</h6>
      <div class="filters">
        @for (lang of languages(); track lang.key) {
          <label class="filter-option">
            <input class="choice" type="radio" name="language" [attr.data-testid]="'setting-language-' + lang.key" [checked]="selectedLanguage() === lang.key" (change)="selectLanguage(lang.key)">
            <span>{{ lang.label | translate }}</span>
          </label>
        }
      </div>
    </div>
  }

  @if (hasMultiCurrency()) {
    <div>
      <h6>{{ 'SETTINGS.CURRENCY' | translate }}</h6>
      <div class="filters">
        @for (currency of currencies(); track currency) {
          <label class="filter-option">
            <input class="choice" type="radio" name="currency" [checked]="selectedCurrency() === currency" (change)="selectCurrency(currency)">
            <span>{{ currency }}</span>
          </label>
        }
      </div>
    </div>
  }

  <button class="btn" data-testid="setting-confirm" (click)="confirm()">
    {{ 'ACTIONS.CONFIRM' | translate }}
  </button>
</div>
